import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
          <div className="text-sm text-gray-500">
            &copy; {currentYear} Luminoso. All rights reserved.
          </div>

          <div className="flex items-center gap-6 text-sm text-gray-400">
            <a
              href="https://twitter.com/LuminosoApp"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-600 transition-colors"
            >
              @LuminosoApp
            </a>
            <span className="hidden sm:inline text-gray-300">·</span>
            <span className="hidden sm:inline">
              Financial data for smarter decisions
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
